export enum EditErrorType {
  FailedToLoadModel = 1,
  FailedToRefreshModel = 2,
  FailedToUpdateModel = 3,
}
